module.exports = __webpack_public_path__ + "static/team-f7ea493b9eae9aa45f63a74e146d917d.svg";